import { twMerge } from 'tailwind-merge';
import Markdown from 'react-markdown';
import { isString } from '@witmetrics/utils/strings';
import { parseMentions } from '@witmetrics/unison-core';
import Box from '@/components/Box';
import { classes, styles } from './utils';

export type NoteProps = {
  className?: string;
  value: string;
};

export default function Note({ className, value }: NoteProps) {
  const mentions = parseMentions(value);
  return (
    <Box
      sx={styles.wrapper}
      className={twMerge(
        classes.wrapper,
        mentions.length > 1 && classes.mentionsWrapper,
        className
      )}>
      {mentions.map((content, i) =>
        isString(content) ? (
          <span key={i}>
            <Markdown>{content}</Markdown>
          </span>
        ) : (
          <span key={i} className={classes.mention}>
            {content.plainText}
          </span>
        )
      )}
    </Box>
  );
}
